import DefaultHeader from "../components/default-header";
import DefaultFooter from "../components/default-footer";
import blogsData from "./../data/blogs";
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ListBlog = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const totalPages = 5;

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
  }, []);

  const catContent = [
    { id: 1, name: "Hotel", number: "92" },
    { id: 2, name: "Car", number: "55" },
    { id: 3, name: "Holiday Rental", number: "75" },
    { id: 4, name: "Travel Guides", number: "62" },
    { id: 5, name: "Flights", number: "34" },
  ];

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
  }

  const teal = "#294b5a";
  const tealDark = "#1a2f38";
  const gold = "#D3BE76";
  const cream = "#faf8f3";
  const muted = "#7a9aaa";

  const cardStyle: React.CSSProperties = {
    background: "#fff",
    borderRadius: "16px",
    border: "1px solid #e8eef1",
    padding: "28px",
    marginBottom: "24px",
  };

  const sidebarTitleStyle: React.CSSProperties = {
    fontSize: "19px",
    fontWeight: 700,
    color: tealDark,
    marginBottom: "18px",
    paddingBottom: "12px",
    borderBottom: "1px solid #eef1f3",
    position: "relative",
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');

        .blg-page { font-family: 'Jost', sans-serif; }

        .blg-hero {
          position: relative; height: 340px;
          overflow: hidden; display: flex;
          align-items: flex-end; padding-bottom: 56px;
        }
        .blg-hero__bg {
          position: absolute; inset: 0;
          width: 100%; height: 100%;
          object-fit: cover; filter: brightness(0.32);
        }
        .blg-hero__overlay {
          position: absolute; inset: 0;
          background: linear-gradient(150deg, rgba(41,75,90,0.80) 0%, rgba(26,47,56,0.55) 100%);
        }
        .blg-hero__inner {
          position: relative; z-index: 2;
          width: 100%; padding: 0 48px;
        }
        .blg-hero__eyebrow {
          display: inline-flex; align-items: center; gap: 10px;
          font-size: 11px; font-weight: 600;
          color: #D3BE76; margin-bottom: 14px;
        }
        .blg-hero__eyebrow::before {
          content: ''; display: block;
          width: 32px; height: 1.5px; background: #D3BE76;
        }
        .blg-hero h1 {
          font-size: 28px;
          font-weight: 700; color: #fff;
          line-height: 1.1; margin: 0;
        }
        .blg-hero h1 em { font-style: italic; color: #D3BE76; }

        .blg-card {
          display: grid; grid-template-columns: 260px 1fr;
          background: #fff; border-radius: 16px;
          overflow: hidden; border: 1px solid #e8eef1;
          text-decoration: none; margin-bottom: 24px;
          transition: box-shadow 0.3s, transform 0.3s, border-color 0.3s;
        }
        .blg-card:hover {
          box-shadow: 0 16px 48px rgba(41,75,90,0.11);
          transform: translateY(-3px);
          border-color: rgba(211,190,118,0.45);
        }
        .blg-card__img {
          position: relative; overflow: hidden; min-height: 210px;
        }
        .blg-card__img img {
          width: 100%; height: 100%;
          object-fit: cover; display: block;
          transition: transform 0.5s ease;
        }
        .blg-card:hover .blg-card__img img { transform: scale(1.06); }
        .blg-card__body {
          padding: 28px 32px;
          display: flex; flex-direction: column; justify-content: center;
          position: relative;
        }
        .blg-card__body::before {
          content: ''; position: absolute;
          left: 0; top: 50%; transform: translateY(-50%);
          width: 3px; height: 44px;
          background: #D3BE76; border-radius: 2px;
          opacity: 0; transition: opacity 0.3s;
        }
        .blg-card:hover .blg-card__body::before { opacity: 1; }
        .blg-card__tag {
          font-size: 10px; font-weight: 600;
          color: #D3BE76; background: rgba(211,190,118,0.12);
          padding: 4px 12px; border-radius: 30px;
          display: inline-block; margin-bottom: 10px;
          align-self: flex-start;
        }
        .blg-card__date {
          font-size: 12.5px; color: #7a9aaa;
          margin-bottom: 10px; display: block;
        }
        .blg-card__title {
          font-size: 22px; font-weight: 700;
          color: #1a2f38; line-height: 1.3;
          margin: 0 0 10px;
          transition: color 0.2s;
        }
        .blg-card:hover .blg-card__title { color: #294b5a; }
        .blg-card__excerpt {
          font-size: 14px; color: #6b8a96;
          line-height: 1.75; margin: 0 0 18px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .blg-card__cta {
          display: inline-flex; align-items: center; gap: 8px;
          font-size: 12px; font-weight: 600;
          color: #294b5a;
          transition: gap 0.25s, color 0.2s;
        }
        .blg-card:hover .blg-card__cta { gap: 14px; color: #3a6475; }
        .blg-card__cta::after { content: '→'; transition: transform 0.2s; }
        .blg-card:hover .blg-card__cta::after { transform: translateX(3px); }

        .blg-pagination {
          display: flex; align-items: center;
          justify-content: space-between; flex-wrap: wrap; gap: 16px;
          padding-top: 36px; border-top: 1px solid #e8eef1;
        }
        .blg-pages { display: flex; gap: 6px; align-items: center; }
        .blg-page-btn {
          width: 36px; height: 36px; border-radius: 10px;
          display: flex; align-items: center; justify-content: center;
          font-size: 13.5px; font-weight: 500; cursor: pointer;
          border: 1px solid #e0e8ec; color: #1a2f38; background: #fff;
          transition: all 0.2s; user-select: none;
        }
        .blg-page-btn:hover { background: #294b5a; color: #fff; border-color: #294b5a; }
        .blg-page-btn.is-active { background: #294b5a; color: #fff; border-color: #294b5a; font-weight: 600; }
        .blg-page-btn.is-dots { cursor: default; border: none; color: #7a9aaa; }

        .sb-search-wrap { position: relative; }
        .sb-search-wrap input {
          width: 100%; height: 44px; padding: 0 48px 0 16px;
          border: 1.5px solid #e0e8ec; border-radius: 10px;
          font-family: 'Jost', sans-serif; font-size: 14px;
          color: #1a2f38; outline: none;
          background: #faf8f3;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .sb-search-wrap input:focus {
          border-color: #294b5a;
          box-shadow: 0 0 0 3px rgba(41,75,90,0.08);
          background: #fff;
        }
        .sb-search-wrap input::placeholder { color: #7a9aaa; }
        .sb-search-wrap button {
          position: absolute; right: 0; top: 0; bottom: 0;
          width: 44px; background: #294b5a; border: none;
          border-radius: 0 10px 10px 0; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          transition: background 0.2s;
        }
        .sb-search-wrap button:hover { background: #3a6475; }
        .sb-search-wrap button i { color: #fff; font-size: 15px; }

        .sb-cat-row {
          display: flex; align-items: center; justify-content: space-between;
          padding: 9px 0; border-bottom: 1px dashed #eef1f3;
          text-decoration: none; transition: padding-left 0.2s;
        }
        .sb-cat-row:last-child { border-bottom: none; }
        .sb-cat-row:hover { padding-left: 6px; }
        .sb-cat-name { font-size: 14px; color: #3d5f6e; font-weight: 500; transition: color 0.2s; }
        .sb-cat-row:hover .sb-cat-name { color: #294b5a; }
        .sb-cat-badge {
          background: #294b5a; color: #fff;
          padding: 2px 10px; border-radius: 30px;
          font-size: 11px; font-weight: 600;
          transition: background 0.2s, color 0.2s;
        }
        .sb-cat-row:hover .sb-cat-badge { background: #D3BE76; color: #1a2f38; }

        .sb-recent-item {
          display: flex; gap: 14px; align-items: flex-start;
          padding: 10px 0; border-bottom: 1px solid #eef1f3;
          text-decoration: none; transition: padding-left 0.2s;
        }
        .sb-recent-item:last-child { border-bottom: none; padding-bottom: 0; }
        .sb-recent-item:hover { padding-left: 5px; }
        .sb-recent-img {
          width: 62px; height: 62px; min-width: 62px;
          border-radius: 10px; object-fit: cover;
          transition: transform 0.3s;
        }
        .sb-recent-item:hover .sb-recent-img { transform: scale(1.04); }
        .sb-recent-title {
          font-size: 13px; font-weight: 500; color: #1a2f38;
          line-height: 1.45; margin-bottom: 5px;
          display: -webkit-box; -webkit-line-clamp: 2;
          -webkit-box-orient: vertical; overflow: hidden;
          transition: color 0.2s;
        }
        .sb-recent-item:hover .sb-recent-title { color: #294b5a; }
        .sb-recent-date {
          font-size: 11.5px; color: #7a9aaa;
          display: flex; align-items: center; gap: 5px;
        }
        .sb-recent-date::before {
          content: ''; width: 10px; height: 1px;
          background: #D3BE76; display: block;
        }

        .sb-tag {
          display: inline-block; padding: 5px 14px;
          border-radius: 30px; font-size: 12px; font-weight: 500;
          color: #294b5a; border: 1.5px solid rgba(41,75,90,0.2);
          background: transparent; text-decoration: none;
          transition: all 0.2s; text-transform: capitalize;
        }
        .sb-tag:hover { background: #294b5a; color: #fff; border-color: #294b5a; }

        .sb-newsletter {
          background: #1a2f38; border-radius: 16px;
          padding: 30px 26px; position: relative; overflow: hidden;
        }
        .sb-newsletter::before {
          content: ''; position: absolute;
          top: -40px; right: -40px;
          width: 130px; height: 130px; border-radius: 50%;
          background: rgba(211,190,118,0.09); pointer-events: none;
        }
        .sb-newsletter__title {
          font-size: 21px; font-weight: 700; color: #fff;
          margin-bottom: 8px; line-height: 1.25;
        }
        .sb-newsletter__text {
          font-size: 13px; color: rgba(255,255,255,0.5);
          line-height: 1.65; margin-bottom: 18px;
        }
        .sb-newsletter input {
          width: 100%; height: 42px; padding: 0 14px;
          border-radius: 9px; border: 1.5px solid rgba(255,255,255,0.14);
          background: rgba(255,255,255,0.07); color: #fff;
          font-family: 'Jost', sans-serif; font-size: 13px;
          outline: none; margin-bottom: 9px;
          transition: border-color 0.2s;
        }
        .sb-newsletter input:focus { border-color: #D3BE76; }
        .sb-newsletter input::placeholder { color: rgba(255,255,255,0.3); }
        .sb-newsletter button {
          width: 100%; height: 42px;
          background: linear-gradient(90deg, #D3BE76 0%, #c4ae62 100%);
          color: #1a2f38; font-family: 'Jost', sans-serif;
          font-size: 12px; font-weight: 700;
          border: none; border-radius: 9px;
          cursor: pointer; transition: opacity 0.2s, transform 0.2s;
        }
        .sb-newsletter button:hover { opacity: 0.88; transform: translateY(-1px); }

        .sb-title-gold::after {
          content: ''; position: absolute;
          bottom: -1px; left: 0;
          width: 36px; height: 2px; background: #D3BE76;
        }

        @media (max-width: 991px) {
          .blg-card { grid-template-columns: 1fr; }
          .blg-card__img { min-height: 200px; }
          .blg-hero__inner { padding: 0 24px; }
        }
      `}</style>

      <div className="blg-page">
        <div className="header-margin"></div>
        <DefaultHeader />

        {/* HERO */}
        <section className="blg-hero">
          <img
            className="blg-hero__bg"
            src="https://gotrip-appdir.vercel.app/img/pages/destinations/1.png"
            alt="Blog"
          />
          <div className="blg-hero__overlay"></div>
          <div className="blg-hero__inner">
            <div className="blg-hero__eyebrow">Silver Jarz Journal</div>
            <h1>Travel <em>Stories</em> &<br />Expert Guides</h1>
          </div>
        </section>

        {/* MAIN */}
        <section style={{ padding: "72px 0 100px", background: "#fff" }}>
          <div className="container">
            <div className="row justify-between">

              {/* POSTS */}
              <div className="col-xl-8 col-lg-8">
                {blogsData.slice(4, 9).map((item, index) => (
                  <a
                    href={`/detail-blog/${item.id}`}
                    className="blg-card"
                    key={item.id}
                    data-aos="fade-up"
                    data-aos-delay={index * 80}
                  >
                    <div className="blg-card__img">
                      <img src={item.img} alt={item.title} />
                    </div>
                    <div className="blg-card__body">
                      {item.tag && (
                        <span className="blg-card__tag">{item.tag}</span>
                      )}
                      <span className="blg-card__date">{item.date}</span>
                      <h3 className="blg-card__title">{item.title}</h3>
                      <p className="blg-card__excerpt">{item.details}</p>
                      <span className="blg-card__cta">Read Article</span>
                    </div>
                  </a>
                ))}

                {/* PAGINATION */}
                <div className="blg-pagination">
                  <span style={{ fontSize: 13, color: muted }}>
                    Showing 1–5 of 300+ articles
                  </span>
                  <div className="blg-pages">
                    <div
                      className="blg-page-btn"
                      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    >
                      <i className="icon-chevron-left" style={{ fontSize: 12 }}></i>
                    </div>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
                      <div
                        key={n}
                        className={`blg-page-btn${currentPage === n ? " is-active" : ""}`}
                        onClick={() => setCurrentPage(n)}
                      >
                        {n}
                      </div>
                    ))}
                    <div className="blg-page-btn is-dots">···</div>
                    <div className="blg-page-btn" onClick={() => setCurrentPage(20)}>20</div>
                    <div
                      className="blg-page-btn"
                      onClick={() => setCurrentPage((p) => Math.min(20, p + 1))}
                    >
                      <i className="icon-chevron-right" style={{ fontSize: 12 }}></i>
                    </div>
                  </div>
                </div>
              </div>

              {/* SIDEBAR */}
              <div className="col-xl-3 col-lg-4">
                <div style={{ position: "sticky", top: 100 }}>

                  {/* Search */}
                  <div style={cardStyle} data-aos="fade-left">
                    <div className="sb-title-gold" style={sidebarTitleStyle}>Search</div>
                    <form className="sb-search-wrap" onSubmit={handleSubmit}>
                      <input
                        type="text"
                        placeholder="Search articles..."
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                      <button type="submit">
                        <i className="icon-search"></i>
                      </button>
                    </form>
                  </div>

                  {/* Categories */}
                  <div style={cardStyle} data-aos="fade-left" data-aos-delay={100}>
                    <div className="sb-title-gold" style={sidebarTitleStyle}>Categories</div>
                    {catContent.map((item) => (
                      <a href="/blog-list-v1" className="sb-cat-row" key={item.id}>
                        <span className="sb-cat-name">{item.name}</span>
                        <span className="sb-cat-badge">{item.number}</span>
                      </a>
                    ))}
                  </div>

                  {/* Recent Posts */}
                  <div style={cardStyle} data-aos="fade-left" data-aos-delay={150}>
                    <div className="sb-title-gold" style={sidebarTitleStyle}>Recent Posts</div>
                    {blogsData.slice(3, 6).map((item) => (
                      <a href={`/blog-details/${item.id}`} className="sb-recent-item" key={item.id}>
                        <img className="sb-recent-img" src={item.img} alt={item.title} />
                        <div>
                          <div className="sb-recent-title">{item.title}</div>
                          <div className="sb-recent-date">{item.date}</div>
                        </div>
                      </a>
                    ))}
                  </div>

                  {/* Tags */}
                  <div style={cardStyle} data-aos="fade-left" data-aos-delay={200}>
                    <div className="sb-title-gold" style={sidebarTitleStyle}>Tags</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", paddingTop: "4px" }}>
                      {blogsData.slice(0, 7).map((item) => (
                        <a href={`/blog-details/${item.id}`} className="sb-tag" key={item.id}>
                          {item.tag}
                        </a>
                      ))}
                    </div>
                  </div>

                  {/* Newsletter */}
                  <div className="sb-newsletter" data-aos="fade-left" data-aos-delay={250}>
                    <div className="sb-newsletter__title">
                      Stay inspired.<br />Travel smarter.
                    </div>
                    <p className="sb-newsletter__text">
                      Get the latest travel tips and exclusive offers in your inbox.
                    </p>
                    <input type="email" placeholder="Your email address" />
                    <button type="button">Subscribe</button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

        <DefaultFooter />
      </div>
    </>
  );
};

export default ListBlog;